<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<table v-else class="table table-sm table-bordered">
            <thead>
                <tr>
                    <th>{{ $t('cards.widget.col_vat_european') }}</th>
                    <th>{{ $t('cards.widget.col_vat_european_count') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ $t('cards.widget.vat_european_label.sans_tva') }}</td>
                    <td class="text-center"><a v-if="sans_tva > 0" href="" @click.prevent="openInfo">{{ sans_tva }}</a><span v-else>{{ sans_tva }}</span></td>
                </tr>
                <tr>
                    <td>{{ $t('cards.widget.vat_european_label.tva_invalide') }}</td>
                    <td class="text-center"><a v-if="tva_invalide > 0" href="" @click.prevent="openInfo">{{ tva_invalide }}</a><span v-else>{{ tva_invalide }}</span></td>
                </tr>
            </tbody>
        </table>

		<b-modal ref="tiersModal" :title="$t('cards.widget.vat_european_modal_title')" hide-footer size="lg">
			<p>{{ $t('cards.widget.vat_european_modal_intro') }}</p>
			<p>
				<router-link :to="{ name: 'tiersListeOnline' }">{{ $t('cards.widget.vat_european_modal_link') }}</router-link>
			</p>
			<ul class="mb-0">
				<li>{{ $t('cards.widget.vat_european_modal_filter_sans_tva') }}</li>
				<li>{{ $t('cards.widget.vat_european_modal_filter_tva_invalide') }}</li>
			</ul>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetVatEuropean',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			sans_tva: 0,
			tva_invalide: 0,
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			// Config du widget : pays à exclure de la vérification TVA.
			const config = this.widget.dashboardwidgets_config
			const res = await this.getVatEuropeanStats(config.pays_exclus)
            this.sans_tva = res['sans_tva']
            this.tva_invalide = res['tva_invalide']
			this.loading = false
		},

		openInfo() {
			this.$refs.tiersModal.show()
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
